<template>
    <div>
        <v-row>
            <div class="mt-2 mb-4 ml-3">
                <v-btn 
                    color="warning" 
                    style="width: 100px" 
                    class="mr-4" 
                    @click="backHandler"> 
                        {{$t('button.back')}}
                </v-btn>
                <v-btn 
                    v-if="parentObject.pmkpiexercisestatus != 'REVIEWED'"
                    color="primary" 
                    style="width: 100px" 
                    class="mr-4" 
                    @click="addProgress"> 
                        {{$t('button.addnew')}}
                </v-btn>
            </div>
        </v-row>
        <h1 class="mb-3 blue--text">{{$t('pmselfservice.kpiprogressandcomments')}}</h1>

        <v-container fluid style="padding: 0;">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card style="background-color: #1261a0; color:white;">
                        <v-card-title>
                            <h4>{{ parentObject.kpi.goal }}</h4>
                        </v-card-title>
                        <v-card-text>
                            <v-expansion-panels v-model="expandedPanelKPI">
                                <v-expansion-panel>
                                    <v-expansion-panel-header style="background-color: white; color:#1261a0; display: flex; justify-content: space-between; align-items: center;">
                                        <div style="flex: 1; text-align: left; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.weightage')}}: <strong>{{ parentObject.kpi.weightage }}%</strong>
                                        </div>

                                        <div v-if="parentObject.kpi.progress" style="flex: 1; text-align: right; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.progress')}}: <strong>{{ parentObject.kpi.progress }}<span v-if="parentObject.basedonpercentage">%</span></strong>
                                        </div>
                                        <div v-else style="flex: 1; text-align: right; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.progress')}}: <strong>0%</strong>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.KPI')}}
                                            <br>
                                            <strong>{{ parentObject.kpi.kpi }}</strong>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('columns.target')}}
                                            <br>
                                            <strong>{{ parentObject.kpi.target }}</strong>
                                        </div>
                                        <div v-if="parentObject.kpi.threshold" class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.threshold')}} 
                                            <br>
                                            <strong>{{ parentObject.kpi.threshold }}</strong>
                                        </div>
                                        <div v-if="parentObject.kpi.stretch" class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.stretch')}}
                                            <br>
                                            <strong>{{ parentObject.kpi.stretch }}</strong>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card style="background-color: #1261a0; color:white;">
                        <v-card-title>
                            <h4>{{$t('pmselfservice.progressandcomments')}}</h4>
                        </v-card-title>
                        <v-card-text>
                            <v-expansion-panels multiple v-model="expandedPanelProgressReviews">
                                <v-expansion-panel v-for="review in progressReviewList" :key="review.id">
                                    <v-expansion-panel-header style="background-color: white; color:#1261a0; display: flex; justify-content: space-between; align-items: center;">
                                        <div style="flex: 2; text-align: left; white-space: nowrap;">
                                            <strong>
                                                <span v-if="review.isGenerated == 1" style="margin-right: 4px;">*</span>
                                                {{ review.reviewdate }}
                                            </strong>
                                        </div>

                                        <div style="flex: 1; text-align: center; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.weightage')}}: <strong>{{ review.achievement }}%</strong>
                                        </div>

                                        <div v-if="review.progress" style="flex: 1; text-align: right; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.progress')}}: 
                                            <strong>
                                                {{ review.progress }}<span v-if="parentObject.basedonpercentage">%</span>
                                            </strong>
                                        </div>
                                        <div v-else style="flex: 1; text-align: right; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.progress')}}: <strong>0%</strong>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.achievement')}}
                                            <br>
                                            <strong>{{ review.achievement }}</strong>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('appraisalrecord.reviewer')}}
                                            <br>
                                            <strong>{{ review.reviewername }} - {{ review.reviewercode}}</strong>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('columns.comment')}}<br>

                                            <template v-if="review.comments.length > 0">
                                                <div v-for="(c, i) in review.comments" :key="i" class="mb-1">
                                                <strong>{{ c.staffname }} - {{ c.staffcode }} : </strong>
                                                <span>{{ c.comment }}</span>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <span>-</span>
                                            </template>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('recstaffdetails.attachment')}}
                                            <br>
                                            <p style="font-size: 0.75rem;"> 
                                                <a v-bind:href="review.attach"  v-bind:download="review.attachname">
                                                    {{review.attachname}}
                                                </a>
                                            </p>
                                        </div>
                                        <!-- <v-row v-if="formData.attach" class="pb-n4 mt-n8 pl-0 ml-0">
                                            <v-col cols="3" class="ml-0 pl-0">
                                                <p style="font-size: 0.75rem;"> <b>{{ $t('recstaffdetails.attachment') }}</b> - 
                                                    <a v-bind:href="this.formData.attach"  v-bind:download="this.formData.attachname">
                                                        {{formData.attachname}}
                                                    </a>
                                                </p>
                                            </v-col>
                                        </v-row> -->
                                        <div v-if="review.reviewerid == formData.reviewerid || review.isGenerated" style="text-align: right;"> 
                                            <v-btn v-if="parentObject.pmkpiexercisestatus != 'REVIEWED'" color="primary" class="mr-2" @click="editProgress(review)">
                                                  {{$t('button.edit')}}
                                            </v-btn>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="progressDialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span style="font-weight: bold;" class="mb-2 mt-6">{{$t('pmselfservice.addprogressandcomments')}}</span>
                    </v-row>

                    <div class="mt-6">
                        <div class="mr-3">
                            <v-row class="pb-n4 mt-n7">
                                <v-col cols="3" class="pl-0 pb-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.reviewdate')"
                                        type="date"
                                        :rules="[rules.required]"
                                        v-model="formData.reviewdate"
                                        dense
                                        class="v-input"
                                        :readonly="formData.isGenerated == 1"
                                        :background-color="formData.isGenerated == 1 ? '#ffeab2' : undefined"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-col cols="6" class="mx-0">
                                    <v-row>
                                        <v-col cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.achievement')"
                                                type="number"
                                                :rules="[rules.required]"
                                                v-model="formData.achievement"
                                                ref="target"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="isEdit" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.progress')"
                                                type="number"
                                                v-model="formData.progress"
                                                ref="stretch"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-textarea
                                    outlined
                                    :label="$t('columns.comment')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.comment"
                                    dense
                                    class="v-input"
                                    auto-grow
                                ></v-textarea>
                            </v-row>
                            <v-row>
                                <v-col cols="11" class="pb-n4 mt-n8">
                                    <v-file-input 
                                        ref="attach"
                                        :label="formData.attach ? 'Reference: ' + formData.attachname : 'No file selected'" 
                                        outlined 
                                        v-model="fileHolder"
                                        @change="fileToBase64('formData')"
                                        dense
                                    ></v-file-input>
                                </v-col>
                                <v-col cols="1" sm="1" class="pb-n4 mt-n4">
                                    <v-icon
                                        class="ml-2"
                                        @click="deleteItemHandler"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveHandler">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeHandler">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import ErrorDialog from "../../components/common/ErrorDialog";

export default {

    props: {
        parentObject: Object,
    },

    components: {
        "app-error": ErrorDialog,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            progressDialog: false,

            formData: {
                id: this.parentObject.kpi.id,
                progreselfservicereviewid: null,
                progreselfservicereviewcommentid: null,
                reviewdate: null,
                achievement: null,
                progress: null,
                isGenerated: 0, // Default to 0, will be set to 1 if the review is generated
                reviewerid: this.$store.getters.staffId, 
                attach: null,
                attachname: null,
                comment: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            progressReviewList: [],
            progressCommentsList: [],
            staffList: [],

            isErr: false,
            errMsg: '',
            isEdit: false,
            expandedPanelKPI: 0,
            expandedPanelProgressReviews: [],
        };
    },

    watch: {
        progressReviewList(newList) {
            this.expandedPanelProgressReviews = newList.map((_, i) => i);
        }
    },

    methods: {
        deleteItemHandler() {
          this.formData.attach = ''
          this.formData.attachname = ''
        },

        fileToBase64() {
          if (this.fileHolder) {
            var file = this.$refs.attach.internalValue;
                this.formData.attachname = this.fileHolder.name
            
            var reader = new FileReader();

            reader.onloadend = () => {
                //var b64 = reader.result.replace(/^data:.+base64,/, '');
                var b64 = reader.result;
                  this.formData.attach = b64
            }

            reader.readAsDataURL(file);
          } else {
                this.formData.attach = null
          }
        },

        backHandler(){
            this.$router.push({ name: 'selfserviceperformance' });
        },

        addProgress() {
            this.isEdit = false;
            this.resetSelections();
            this.progressDialog = true;
        },

        editProgress(review){
            this.isEdit = true;
            this.formData = { ...this.formData, ...review};
            this.formData.comment = review.comments.map(comment => comment.comment).join('\n');
            this.formData.progreselfservicereviewid = review.id;
            this.formData.progreselfservicereviewcommentid = review.comments.map(comment => comment.id).join(',');
            this.formData.isGenerated = review.isGenerated;
            this.formData.attach = review.attach;
            this.formData.attachname = review.attachname;
            const reviewDate = moment(review.reviewdate, 'DD-MM-YYYY'); 
            if (reviewDate.isValid()) {
                this.formData.reviewdate = reviewDate.format('YYYY-MM-DD'); 
            } else {
                console.error("Invalid date:", review.reviewdate);
                this.formData.reviewdate = ""; // Handle invalid date case
            }
            console.log("Edit Progress:", this.formData);
            this.progressDialog = true;
        },

        saveHandler() {
            //ADD is most commonly for progress review isGenerated != 1, so does not affect much
            //EDIT is most commonly for progress review isGenerated = 1, so it will affect the Individual KPI progress

            const vm = this;

            //Calculate progress
            if (vm.parentObject.kpi.basedonpercentage){
                vm.formData.progress = Number(((vm.formData.achievement / vm.parentObject.kpi.target) * 100).toFixed(2));
            }else{
                vm.formData.progress = vm.formData.achievement;
            }

            vm.formData.reviewerid = this.$store.getters.staffId;
            if(!vm.isEdit){
                this.$store.dispatch('post', {url: "/kpiindividual/progressreview/create/", payload: vm.formData})
                .then(async (res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        const newReview = res.data.result; // Response data from the server

                        // Find the matching staff for the reviewer
                        const matchingStaff = vm.staffList.find(staff => staff.value === newReview.reviewerid);

                        // Format the new review object
                        const formattedReview = {
                            ...newReview,
                            reviewdate: moment(newReview.reviewdate).format('DD-MM-YYYY'), // Format the review date
                            reviewername: matchingStaff ? matchingStaff.psnname : null,
                            reviewcompany: matchingStaff ? matchingStaff.staffcompany : null,
                            reviewercode: matchingStaff ? matchingStaff.staffcode : null,
                            comments: [], // Initialize comments as an empty array
                        };

                        // Fetch comments for the new review (if needed)
                        const comments = await vm.loadProgressCommentsList(formattedReview.kpiexerciseindkpiprgid);
                        formattedReview.comments = comments;

                        // Add the formatted review to the progressReviewList
                        vm.progressReviewList.push(formattedReview);

                        console.log("Newly added review:", formattedReview);
                        this.closeHandler();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }else{
                this.$store.dispatch('put', {url: "/kpiindividual/progressreview/" + vm.formData.progreselfservicereviewid, payload: vm.formData})
                .then(async (res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        // Update progress review comment
                        await vm.updateProgressReviewComment(vm.formData.progreselfservicereviewid, vm.formData.comment);

                        // Update the progressReviewList
                        const updatedReview = { ...vm.formData };

                        // Find the matching staff for the reviewer
                        const matchingStaff = vm.staffList.find(staff => staff.value === updatedReview.reviewerid);

                        // Format the updated review object
                        const formattedReview = {
                            ...updatedReview,
                            reviewdate: moment(updatedReview.reviewdate).format('DD-MM-YYYY'),
                            reviewername: matchingStaff ? matchingStaff.psnname : null,
                            reviewcompany: matchingStaff ? matchingStaff.staffcompany : null,
                            reviewercode: matchingStaff ? matchingStaff.staffcode : null,
                        };

                        // Fetch the updated comments for this review
                        const comments = await vm.loadProgressCommentsList(updatedReview.progreselfservicereviewid);
                        formattedReview.comments = comments;

                        // Update the specific review in the progressReviewList
                        const index = vm.progressReviewList.findIndex(item => item.id === formattedReview.id);
                        if (index !== -1) {
                            vm.$set(vm.progressReviewList, index, formattedReview); // Ensure reactivity
                        }

                        if (formattedReview.isGenerated == 1) {
                           if (vm.parentObject.kpi.pmkpifinalscorecalmethodid == 1) { // Take Average
                            // Calculate the average progress from all reviews that isGenerated = 1
                            const generatedReviews = vm.progressReviewList.filter(item => item.isGenerated === 1);
                            if (generatedReviews.length > 0) {
                                const totalProgress = generatedReviews.reduce((sum, item) => sum + item.progress, 0);
                                vm.parentObject.kpi.progress = totalProgress / generatedReviews.length;
                            } 
                            } else if (vm.parentObject.kpi.pmkpifinalscorecalmethodid == 2) { // Take Last
                                //if calculation = take last 
                                //check between review dates and update progress
                                const latestReview = this.progressReviewList
                                    .filter(item => item.isGenerated === 1)
                                    .reduce((latest, item) => {
                                        return (!latest || (item.reviewdate && item.reviewdate > latest.reviewdate)) ? item : latest;
                                    }, null);
                                if (latestReview) {
                                    vm.parentObject.kpi.progress = latestReview.progress;
                                }
                            } 
                        } 
                        
                        console.log("Updated review:", formattedReview);
                        this.closeHandler();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        async updateProgressReviewComment(progressReviewId, comment) {
            try {
                await this.$store.dispatch('put', { 
                    url: `/sskpiindividual/progressreview/comment/${progressReviewId}`, 
                    payload: { comments: comment, commentby: this.$store.getters.staffId , stamp: 0, updatedby: this.$store.getters.userId }  
                });
                console.log(`Updated comment for progress review ID: ${progressReviewId}`);
            } catch (err) {
                console.error("Error updating progress review comment:", err);
            }
        },

        loadProgressReviewList() {
            const vm = this;
            this.$store.dispatch('get', { url: "/kpiindividual/progressreview/" + this.parentObject.kpi.id })
                .then(async function (res) {
                    vm.progressReviewList = res.data.rec;
                    // Format review dates and fetch staff details
                    vm.progressReviewList.forEach(review => {
                        review.reviewdate = moment(review.reviewdate).format('DD-MM-YYYY');

                        // Find the matching staff from staffList
                        const matchingStaff = vm.staffList.find(staff => staff.value === review.reviewerid);

                        if (matchingStaff) {
                            // Add staff information to the review
                            review.reviewername = matchingStaff.psnname;
                            review.reviewcompany = matchingStaff.staffcompany;
                            review.reviewercode = matchingStaff.staffcode;
                        }
                    });

                    // Fetch comments for each progress review
                    await Promise.all(
                        vm.progressReviewList.map(async review => {
                            const comments = await vm.loadProgressCommentsList(review.id);
                            console.log("comments: ", comments);
                            vm.$set(review, 'comments', comments); // Use Vue's reactivity system
                        })
                    );

                    console.log("progressReviewList with comments: ", vm.progressReviewList);
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
        },


        async loadProgressCommentsList(id) {
            try {
                const res = await this.$store.dispatch('get', { url: "/kpiindividual/progressreview/comment/" + id });
                return res.data.rec.map(comment => {
                    // Find the matching staff from staffList
                    const matchingStaff = this.staffList.find(staff => staff.value === comment.commentby);

                    return {
                        id: comment.id,
                        comment: comment.comments,
                        commentBy: comment.commentby,
                        progressId: comment.kpiexerindkpiprgid,
                        staffname: matchingStaff ? matchingStaff.psnname : null,
                        staffcompany: matchingStaff ? matchingStaff.staffcompany : null,
                        staffcode: matchingStaff ? matchingStaff.staffcode : null,
                    };
                });
            } catch (err) {
                console.error("Error in loadProgressCommentsList:", err);
                return [];
            }
        },

        closeHandler() {
            this.progressDialog = false;
            this.isErr = false;
            this.isEdit= false;
            this.resetSelections();
        },


        resetSelections() {
            this.formData = {
                id: this.parentObject.kpi.id,
                reviewdate: null,
                achievement: null,
                progress: null,
                reviewerid: this.$store.getters.staffId,
                comment: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            };
        },

        async loadStaff(){
            const vm = this;

            try {
                const res = await vm.$store.dispatch("get", {
                    url: `/staff/alls`
                });

                const staffFull = res.data.rec || [];

                vm.staffList = staffFull.map(staff => ({
                    text: staff.psndetails,
                    psnname: staff.psnname,
                    staffcode: staff.staffcode,
                    staffcompany: staff.compnyname,
                    value: staff.id,
                }));
                console.log("STAFFLIST", vm.staffList);

            } catch (err) {
                console.error("Error in loadStaff:", err);
            }
        },
    },

    async mounted() {
        try {
            await this.loadStaff();
            this.loadProgressReviewList();
        } catch (err) {
            console.error("Error in mounted:", err);
        }
    },
   
};

</script>

<style>
.v-expansion-panel-header .v-icon.mdi-chevron-down.theme--light {
    color: #1261a0 !important;
}</style>

<style scoped>

</style>